var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12271_19353)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.1 0.799829C9.7 0.299829 11.4 1.19983 11.8 2.79983C12 3.09983 12 3.39983 12 3.69983V18.2998C12 19.9998 10.7 21.2998 9 21.2998C8.7 21.2998 8.4 21.2998 8.1 21.1998L2.1 19.3998C0.9 18.9998 0 17.7998 0 16.4998V5.49983C0 4.19983 0.9 2.99983 2.1 2.59983L8.1 0.799829ZM13 2.99983C13 2.39983 13.4 1.99983 14 1.99983H17C18.7 1.99983 20 3.29983 20 4.99983V5.99983C20 6.59983 19.6 6.99983 19 6.99983C18.4 6.99983 18 6.59983 18 5.99983V4.99983C18 4.39983 17.6 3.99983 17 3.99983H14C13.4 3.99983 13 3.59983 13 2.99983ZM19 14.9998C19.6 14.9998 20 15.3998 20 15.9998V16.9998C20 18.6998 18.7 19.9998 17 19.9998H14C13.4 19.9998 13 19.5998 13 18.9998C13 18.3998 13.4 17.9998 14 17.9998H17C17.6 17.9998 18 17.5998 18 16.9998V15.9998C18 15.4998 18.4 14.9998 19 14.9998ZM7 9.99983C6.4 9.99983 6 10.3998 6 10.9998C6 11.5998 6.4 11.9998 7 11.9998C7.6 11.9998 8 11.5998 8 10.9998C8 10.3998 7.6 9.99983 7 9.99983Z",
    fill: "#028789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10.9998H19M19 10.9998L17 8.99976M19 10.9998L17 12.9998",
    stroke: "#028789",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12271_19353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20.6,
    fill: "white",
    transform: "translate(0 0.699951)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.decbda420045e9ac4d55959d5cf4ea6f.svg";
export { ForwardRef as ReactComponent };